import { AppEnum } from "../Types";

export enum USER_ROLES {
    USER = 'user',
    ADMIN = 'admin',
    SUPER_ADMIN = 'super_admin'
}
export type UserRole = USER_ROLES;

const ROLE_HIERARCHY: Record<UserRole, number> = {
  [USER_ROLES.USER]: 0,
  [USER_ROLES.ADMIN]: 1,
  [USER_ROLES.SUPER_ADMIN]: 2
};

export class RoleHelper  {

    static isUser = (value: string) => value === USER_ROLES.USER;

    static isAdmin = (value: string) => value === USER_ROLES.ADMIN;

    static isSuperAdmin = (value: string) => value === USER_ROLES.SUPER_ADMIN;

    static isAtLeastUser = (value: string) => ROLE_HIERARCHY[value as UserRole] >= ROLE_HIERARCHY.user;

    static isAtLeastAdmin = (value: string) => ROLE_HIERARCHY[value as UserRole] >= ROLE_HIERARCHY.admin;

    static isAtLeastSuperAdmin = (value: string) => ROLE_HIERARCHY[value as UserRole] >= ROLE_HIERARCHY.super_admin;

    static hasAtLeastRole = (requiredRole: UserRole, userRole: UserRole) => ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole];

    static isHigherThan = (prevRole : UserRole, nextRole : UserRole) => ROLE_HIERARCHY[nextRole] > ROLE_HIERARCHY[prevRole];
}